import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'img[cpakErrorImage]',
})
export class ErrorImageDirective {
  constructor(private el: ElementRef) {}

  @HostListener('error')
  private onError(): void {
    this.el.nativeElement.src = '/assets/images/no_image.jpg';
    this.el.nativeElement.onerror = null;
  }
}
